import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { css } from "styled-components";

// BrandDetailsLogo
logoStyles.container = {
    css: css`
        width: 100%;
        margin: 0;
    `,
};

// BrandDetailsImage
imageStyles.container = {
    gap: 5,
    css: css`
        margin: 0;
    `,
};

imageStyles.productLink = {
    css: css`
        text-align: left;
    `,
};

// BrandDetailsCategories
categoriesStyles.container = {
    css: css`
        margin: 0;
    `,
};
